import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { LoginFailedComponent } from './core/components/login-failed/login-failed.component';
import { LogoutSuccessComponent } from './core/components/logout-success/logout-success.component';
import { landingRedirectGuard } from './shared/guards/landing-redirect.guard';
import { rbacGuard } from './shared/guards/rbac.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [MsalGuard, landingRedirectGuard],
    children: [],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
    canActivate: [MsalGuard, rbacGuard('valueChainViewerAuthorizationStatus')],
  },
  {
    path: 'banker-iq',
    loadChildren: () =>
      import('./features/banker-iq/banker-iq.routes').then(
        (m) => m.BANKER_IQ_ROUTES,
      ),
    canActivate: [MsalGuard, rbacGuard('bankerIQAuthorizationStatus')],
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./features/company/company.routes').then((m) => m.COMPANY_ROUTES),
    canActivate: [MsalGuard, rbacGuard('valueChainViewerAuthorizationStatus')],
  },
  {
    path: 'business-input',
    loadChildren: () =>
      import('./features/businessInput/business-input.routes').then(
        (m) => m.BUSINESS_INPUT_ROUTES,
      ),
    canActivate: [MsalGuard, rbacGuard('businessInputAuthorizationStatus')],
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
  },
  {
    path: 'logout-success',
    component: LogoutSuccessComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
